import React from 'react';
import T from 'components/T';
import { InterpolationValues } from 'types/candidateStories';

type Props = {
  value: string;
  interpolationValues?: InterpolationValues;
  className?: string;
};

const TranslatedParagraph = ({
  value,
  interpolationValues = {},
  className,
}: Props) => {
  const classes = `mb-3 ${className ?? 'text-muted'}`;
  return (
    <p className={classes} data-testid='translated-paragraph'>
      <T value={value} {...interpolationValues} />
    </p>
  );
};

export default TranslatedParagraph;
